<div class="ui error message" v-if="getValidationErrors()">
  <div class="header">
    There were some errors with your submission
  </div>
  <ul class="list">
    <template v-for="value, key in getValidationErrors()">
      <li>{{ value[0] }}</li>
    </template>
  </ul>
</div>
